export const RefinanceFiltersMixin = {
    filters: {
        formatMoney(value) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2
            }).format(value);
        },

        formatRate(value) {
            if (value === null || value === undefined) return '';
            // Rates come as integers (e.g. 160 = 1.60%, 199 = 1.99%)
            return (value / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';
        }
    },

    methods: {
        formatMoney(value) {
            return RefinanceFiltersMixin.filters.formatMoney(value);
        },

        formatRate(value) {
            return RefinanceFiltersMixin.filters.formatRate(value);
        }
    }
};
